export enum DeviceOrientationEnum {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape'
}
